function CitySearch(postalCodeEl, postalCityObs) {
  this.$postalCodeEl = postalCodeEl;
  this.postalCityObs = postalCityObs;
}

CitySearch.prototype.init = function() {
  var self = this;
  self.$postalCodeEl.keyup(function() {
    self.getInputText();
  });
};

CitySearch.prototype.getInputText = function() {
  var self = this;
  if (self.$postalCodeInput.val().length === 4) {
    self.searchForCity(self.$postalCodeInput.val());
  }
};

CitySearch.prototype.searchForCity = function(num) {
  if (num === undefined || num === null) {
    return;
  }
  if (num.length !== 4) {
    return;
  }
  var self = this;

  $.getJSON(
    'https://fraktguide.bring.no/fraktguide/postalCode.json?pnr=' +
      num +
      '&callback=?',
    function(data) {
      self.postalCityObs(data.result);
    }
  );
};

module.exports = CitySearch;
